import React, { useState } from "react";
import { useDispatch } from "react-redux";
import UsersRequests from "services/users";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function AddUserAccessDialog({
  open,
  handleClose,
  isALManamger,
}) {
  const [nationalCode, setNationalCode] = useState("");
  const [personalCode, setPersonalCode] = useState("");
  const [relation, setRelation] = useState("کارمند فولاد");
  const [gender, setGender] = useState("male");
  const [type, settType] = useState("CodeMeli");
  const [associationType, setAssociationType] = useState("");

  const [topic, setTopic] = useState("");
  const [topicString, setTopicString] = useState("");

  const classes = useStyles();
  const dispatch = useDispatch();

  const handleAddUserAccess = () => {
    if (isALManamger) {
      const user = {
        identifier: type === "CodeMeli" ? nationalCode : personalCode,
        topic: topic,
        type: type,
      };
      if (topicString) {
        user["topicString"] = topicString;
      }
      dispatch(UsersRequests.addSingleUserAccessMangement(user));
    } else {
      const user = {
        relation: relation,
        gender: gender,
        associationType: associationType,
        personalCode: personalCode,
        nationalCode: nationalCode,
      };
      // if (personalCode) {
      //   user["personnelCode"] = personalCode;
      // } else {
      //   user["nationalCode"] = nationalCode;
      // }
      dispatch(UsersRequests.addSingleUserAccess(user));
    }
    handleClose();
    reset();
  };

  const reset = () => {
    setNationalCode("");
    setPersonalCode("");
    setRelation("کارمند فولاد");
    setGender("male");
    setAssociationType("");
  };

  const addMainAccessContent = (
    <GridContainer className={classes.girdContainer}>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>کد ملی</Typography>
        <TextField
          id="nationalCodeInput"
          label="کد ملی"
          variant="outlined"
          className={classes.customInput}
          value={nationalCode}
          onChange={(e) => setNationalCode(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>کد پرسنلی</Typography>
        <TextField
          id="personalCodeInput"
          label="کد پرسنلی"
          variant="outlined"
          className={classes.customInput}
          value={personalCode}
          onChange={(e) => setPersonalCode(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>نسبت</Typography>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="relation-select-outlined-label">نسبت</InputLabel>
          <Select
            labelId="relation-select-outlined-label"
            id="relation-select-outlined"
            value={relation}
            onChange={(e) => setRelation(e.target.value)}
            label="نسبت"
          >
            <MenuItem value={"کارمند فولاد"}>کارمند فولاد</MenuItem>
            <MenuItem value={"همسر"}>همسر</MenuItem>
            <MenuItem value={"فرزند دختر"}>فرزند دختر</MenuItem>
            <MenuItem value={"فرزند پسر"}>فرزند پسر</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>جنسیت</Typography>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="relation-select-outlined-label">جنسیت</InputLabel>
          <Select
            labelId="relation-select-outlined-label"
            id="relation-select-outlined"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            label="جنسیت"
          >
            <MenuItem value={"male"}>مرد</MenuItem>
            <MenuItem value={"female"}>زن</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>نوع همکاری</Typography>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="relation-select-outlined-label">
            نوع همکاری
          </InputLabel>
          <Select
            labelId="relation-select-outlined-label"
            id="relation-select-outlined"
            value={associationType}
            onChange={(e) => setAssociationType(e.target.value)}
            label="نوع همکاری"
          >
            <MenuItem value={"personnel"}>پرسنل</MenuItem>
            <MenuItem value={"retired"}>بازنشسته</MenuItem>
            <MenuItem value={"contractor"}>پیمانکار</MenuItem>
            <MenuItem value={"saba"}>فولاد صبا</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </GridContainer>
  );

  const addAccessContent = (
    <GridContainer className={classes.girdContainer}>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>نوع</Typography>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="relation-select-outlined-label">نوع</InputLabel>
          <Select
            labelId="relation-select-outlined-label"
            id="relation-select-outlined"
            value={type}
            onChange={(e) => settType(e.target.value)}
            label="نوع"
          >
            <MenuItem value={"CodeMeli"}>کدملی</MenuItem>
            <MenuItem value={"CodePersoneli"}>کد پرسنلی</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {type === "CodeMeli" ? (
        <Grid item xs={12} md={6} className={classes.inputContainer}>
          <Typography>کد ملی</Typography>
          <TextField
            id="nationalCodeInput"
            label="کد ملی"
            variant="outlined"
            className={classes.customInput}
            value={nationalCode}
            onChange={(e) => setNationalCode(e.target.value)}
          />
        </Grid>
      ) : (
        <Grid item xs={12} md={6} className={classes.inputContainer}>
          <Typography>کد پرسنلی</Typography>
          <TextField
            id="personalCodeInput"
            label="کد پرسنلی"
            variant="outlined"
            className={classes.customInput}
            value={personalCode}
            onChange={(e) => setPersonalCode(e.target.value)}
          />
        </Grid>
      )}
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>موضوع</Typography>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="topic-select-outlined-label">موضوع</InputLabel>
          <Select
            labelId="topic-select-outlined-label"
            id="topic-select-outlined"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            label="موضوع"
          >
            <MenuItem value={"General"}>عمومی</MenuItem>
            <MenuItem value={"JoftPooch"}>جفت پوچ</MenuItem>
            <MenuItem value={"Other"}>دیگر</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {topic === "Other" && (
        <Grid item xs={12} md={6} className={classes.inputContainer}>
          <Typography>نام موضوع</Typography>
          <TextField
            id="otherStringInput"
            label="نام موضوع"
            variant="outlined"
            className={classes.customInput}
            value={topicString}
            onChange={(e) => setTopicString(e.target.value)}
          />
        </Grid>
      )}
    </GridContainer>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-add-user-access"
      aria-describedby="alert-add-user-access"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-user-description">
          اضافه کردن کاربر
        </DialogContentText>
        {isALManamger ? addAccessContent : addMainAccessContent}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddUserAccess} color="primary">
          اضافه کردن
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
